import React, { useState, useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { withRouter } from '../../../routes/withRouter';

//Import Store
import store from '../../../store';

//Import Action
import { userLogin, userLoginFB } from '../../../action/users';

//Import Utils
import { setUserSession } from '../../../utils';

//Import Context
import { AuthenticationContext } from '../../pages/others/common/context';

//Import Custom Component
import ForgetPassword from '../../pages/others/repeat-password/modal';
import ModalRegisterClient from '../../pages/others/register-client/modal-client';
// import ModalRegisterContractor from '../../pages/others/register-contractor/modal-contractor';

// const customStyles = {
//   content: {
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     position: 'relative',
//     maxWidth: '940px',
//     marginRight: '1rem',
//     backgroundColor: '#fff'
//   }
// };

Modal.setAppElement('#root');

function LoginModal(props) {
  let location = useLocation();
  const { addClass = "porto-icon" } = props;
  const [userModal, setUserModal] = useState(false);
  const [forgetPassword, setforgetPassword] = useState(false);
  const [registerClient, setregisterClient] = useState(false);
  // const [registerContractor, setregisterContractor] = useState(false);
  const { setLoggedIn } = useContext(AuthenticationContext);

  const openModal = modalType => (e) => {
    e.preventDefault();

    if (modalType === "user-modal") {
      setUserModal(true);
      setforgetPassword(false);
      setregisterClient(false);
      // setregisterContractor(false);
    } else if (modalType === "forget-password") {
      setUserModal(false);
      setforgetPassword(true);
      setregisterClient(false);
      // setregisterContractor(false);
    } else if (modalType === "register-client") {
      setUserModal(false);
      setforgetPassword(false);
      setregisterClient(true);
      // setregisterContractor(false);
    } else if (modalType === "register-contractor") {
      setUserModal(false);
      setforgetPassword(false);
      setregisterClient(false);
      // setregisterContractor(true);
    }
  }

  const backModal = modalType => () => {
    if (modalType === "user-modal") {
      setUserModal(false);
    } else if (modalType === "forget-password") {
      setforgetPassword(false);
      setUserModal(true);
    } else if (modalType === "register-client") {
      setregisterClient(false);
      setUserModal(true);
    } 
  }

  const closeModal = modalType => () => {
    if (modalType === "user-modal") {
      setUserModal(false);
    } else if (modalType === "forget-password") {
      setforgetPassword(false);
    } else if (modalType === "register-client") {
      setregisterClient(false);
    } 
    // else if (modalType === "register-contractor") {
    // setregisterContractor(false);
    // setUserModal(true);
    // }
  }

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleLogin = (e) => {
    e.preventDefault();

    setError(null);
    store.dispatch(userLogin(email, password, setUserSession, setError, location, setLoggedIn, setUserModal));
  }

  const [data, setData] = useState(null);

  const responseFacebook = (response) => {
    setData(response);
  }

  useEffect(() => {
    if (data) {
      store.dispatch(userLoginFB(data, setUserSession, location, setUserModal));
    }
  }, [data])

  return (
    <>
      <Link to="#" className={`login-link ${addClass}`} onClick={openModal("user-modal")} title="Logowanie">
        <span>Zaloguj</span><i className="icon-user-2"></i>
      </Link>
      <Modal
        isOpen={userModal}
        // style={customStyles}
        onRequestClose={closeModal("user-modal")}
        className="login-popup"
        id="login-popup-form"
        overlayClassName="cart-modal-overlay"
        closeTimeoutMS={10}
      >
        <div className="modal-dialog modal-dialog-centered modal-login" role="document">
          <div className="modal-content">
            <button title="Zamknij" type="button" className="mfp-close" onClick={closeModal("user-modal")}>×</button>

            <div className="modal-body mh-100 p-0">
              <div className="modal-wrapper">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="heading mb-1">
                        <h2 className="title">Zaloguj się</h2>
                        <p>Jeśli masz u nas konto, zaloguj się.</p>
                      </div>
                      <form onSubmit={handleLogin} className="mb-1">
                        <div className="mb-1">
                          <label htmlFor="login-phone">Telefon / Adres e-mail <span className="required">*</span></label>
                          <input type="text" className="form-input form-wide" id="login-phone" value={email} onChange={e => setEmail(e.target.value)} />
                        </div>
                        <div className="mb-1">
                          <label htmlFor="login-password">Hasło <span className="required">*</span></label>
                          <input type="password" className="form-input form-wide" id="login-password" value={password} onChange={e => setPassword(e.target.value)} />
                        </div>
                        {error && 
                          <>
                            <div className="text-danger">{error}</div>
                            <div className="text-danger mb-2">W razie potrzeby zadzwoń - tel. <a href="tel:+48531227545">+48 531 227 545</a></div>
                          </>
                        }
                        <div className="row align-items-center mt-2 mb-2">
                          <div className="col-lg-6 col-6">
                            <button type="submit" className="btn btn-primary w-100">Zaloguj się</button>
                          </div>
                          <div className="col-lg-6 col-6">
                            <Link to="#" className="forget-pass link" onClick={openModal("forget-password")}> Zapomniałeś hasła?</Link>
                          </div>
                        </div>
                      </form>
                      <div className="row">
                        <div className="col-lg-12">
                          <FacebookLogin
                            appId="1371896343585257"
                            // appId="723328126080065"
                            fields="name,email"
                            scope="public_profile,email"
                            callback={responseFacebook}
                            icon="fa-facebook"
                            disableMobileRedirect={true}
                            isMobile={false}
                            render={renderProps => (
                              <button onClick={renderProps.onClick} className="fb-button"><i className="icon-facebook"></i> Zaloguj się używając Facebooka</button>
                            )}
                          />
                        </div>
                      </div>
                    </div>

                    <hr className="col-lg-12 mt-2 mb-2 mr-3 ml-3 d-block d-md-none"></hr>

                    <div className="col-lg-6 mb-2">
                      <div className="heading mb-1">
                        <h2 className="title">Utwórz konto</h2>
                        <p>Utwórz konto, aby móc w pełni korzystać z portalu.</p>
                      </div>
                      <div className="row text-center">
                        <div className="col-lg-12 col-12">
                          <Link to="#" className="account-choice" onClick={openModal("register-client")}>Zarejestruj się</Link>
                        </div>
                        {/* <div className="col-lg-6 col-6">
                          <Link to="#" className="account-choice" onClick={openModal("register-contractor")}>Jestem wykonawcą</Link>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="social-login-wrapper">
                <p>Uzyskaj dostęp do swojego konta za pośrednictwem Facebooka.</p>

                <div className="btn-group">
                  <Link to="#" className="btn btn-social-login btn-md btn-facebook mb-1"><i className="icon-facebook"></i><span>Facebook</span></Link>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={forgetPassword}
        // style={customStyles}
        onRequestClose={closeModal("forget-password")}
        contentLabel="login Modal"
        className="login-popup"
        id="login-popup-form"
        overlayClassName="cart-modal-overlay"
        closeTimeoutMS={10}
      >
        <div className="modal-dialog modal-dialog-centered modal-login" role="document">
          <div className="modal-content">
            <button title="Zamknij" type="button" className="mfp-close" onClick={closeModal("forget-password")}>×</button>

            <div className="modal-body mh-100 p-0">
              <ForgetPassword backModal={backModal} {...props} />
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={registerClient}
        // style={customStyles}
        onRequestClose={closeModal("register-client")}
        contentLabel="login Modal"
        className="login-popup"
        id="login-popup-form"
        overlayClassName="cart-modal-overlay"
        closeTimeoutMS={10}
      >
        <div className="modal-dialog modal-dialog-centered modal-login" role="document">
          <div className="modal-content">
            <button title="Zamknij" type="button" className="mfp-close" onClick={closeModal("register-client")}>×</button>

            <div className="modal-body mh-100 p-0">
              <div className="container">
                <ModalRegisterClient setregisterClient={setregisterClient} backModal={backModal} {...props} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* <Modal
        isOpen={registerContractor}
        style={customStyles}
        onRequestClose={closeModal("register-contractor")}
        contentLabel="login Modal"
        className="login-popup"
        id="login-popup-form"
        overlayClassName="cart-modal-overlay"
        closeTimeoutMS={10}
      >
        <div className="modal-wrapper">
          <div className="container">
            <div className="row">
              <ModalRegisterContractor setregisterContractor={setregisterContractor}/>
            </div>
          </div>
          <button title="Zamknij" type="button" className="mfp-close" onClick={closeModal("register-contractor")}>×</button>
        </div>
      </Modal> */}
    </>
  )

}

export default withRouter(LoginModal);